<template>
    <div class="product-popup"  >
        <notifications group="appnotif"  animation-type="velocity" position="top left"></notifications>

        <div class="container w70">

            <h3>{{ getDatasheeet.product_name }} </h3>
            <hr class="line1">
            <div class="float-end og-close" @click="$FModal.hide()"> </div>
            <div class="og-details row">
                <div class="col-lg-7 product-description">




                <div v-html="getDatasheeet.description"></div>
                <div class="read-more"><a :href="'/'+ language_id + '/' + __('__JSON__.termekeink') +  getDatasheeet.url" class="float-end btn btn-product-incart">{{ __('__JSON__.További részletek') }}</a>

                </div>
            </div>
            <div class="col-lg-5 cart-top">

                <div class="prices"><roastopus-product-price  :products="product"></roastopus-product-price></div>

            </div>
            </div>
        </div>
    </div>
</template>
<script>
import find from 'lodash/find';

// import Vue from 'vue';
import mixin from '../../mixin.js'
export default {
    props: {

        product: {
            type: Array
        },
        language_id: {
            type: String
        }        },
        mixins: [mixin],
        data () {
            return {
                // getDatasheeet: {}
            }
        },
        computed: {
            getDatasheeet() {
                console.log('getDatasheeet()');
                if (!this.product || !this.product.length) {
                    return {};
                }
                 return find(this.product, o => o.id == o.parent_id);
            }
        },
        methods: {

        },
        mounted() {

            console.log('product-datasheet-popup Component mounted.');
            // console.log(this.product);

        }
    }

    </script>
